"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMapPrefSlots = exports.useDeletePrefSlots = exports.useCreatePrefSlots = exports.useDeletePrefLabel = exports.useEditPrefLabelDetails = exports.useCreatePrefLabel = exports.useCreateInitialPrefLabels = exports.useManagerDeleteUserPref = exports.useManagerEditUserPref = exports.useEditUserPreferencesConfig = void 0;
var react_query_1 = require("@tanstack/react-query");
var api_1 = require("../../api");
// to edit base points and base jokers
var useEditUserPreferencesConfig = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, preference_configs = params.preference_configs;
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/edit"),
                method: "patch",
                data: { preference_configs: preference_configs },
            });
        } }, options), queryClient);
};
exports.useEditUserPreferencesConfig = useEditUserPreferencesConfig;
// to edit someone's preference in a pref slot
var useManagerEditUserPref = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, data = __rest(params, ["id_itr"]);
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/edit_user_pref"),
                method: "patch",
                data: data,
            });
        } }, options), queryClient);
};
exports.useManagerEditUserPref = useManagerEditUserPref;
// to delete someone's preference in a pref slot
var useManagerDeleteUserPref = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, data = __rest(params, ["id_itr"]);
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/delete_user_pref"),
                method: "delete",
                data: data,
            });
        } }, options), queryClient);
};
exports.useManagerDeleteUserPref = useManagerDeleteUserPref;
// to create a pre-filled initial prefLabel + prefSlots state
// Endpoint: manager/itrs/<id_itr>/preferences/create_initial_pref_labels
var useCreateInitialPrefLabels = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, pref_labels = params.pref_labels;
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/create_initial_pref_labels"),
                method: "post",
                data: { pref_labels: pref_labels },
            });
        } }, options), queryClient);
};
exports.useCreateInitialPrefLabels = useCreateInitialPrefLabels;
// to create a(n) (empty) prefLabel
// Endpoint: manager/itrs/<id_itr>/preferences/create_pref_label
var useCreatePrefLabel = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, new_pref_label = params.new_pref_label;
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/create_pref_label"),
                method: "post",
                data: __assign({}, new_pref_label),
            });
        } }, options), queryClient);
};
exports.useCreatePrefLabel = useCreatePrefLabel;
// to edit the details of a prefLabel
// Endpoint: manager/itrs/<id_itr>/preferences/<id_pref_label>/edit_pref_label_details
var useEditPrefLabelDetails = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, id_pref_label = params.id_pref_label, pref_label = params.pref_label;
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/").concat(id_pref_label, "/edit_pref_label_details"),
                method: "patch",
                data: __assign({}, pref_label),
            });
        } }, options), queryClient);
};
exports.useEditPrefLabelDetails = useEditPrefLabelDetails;
// to delete a prefLabel
// Endpoint: manager/itrs/<id_itr>/preferences/<id_pref_label>/delete_pref_label
var useDeletePrefLabel = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, id_pref_label = params.id_pref_label;
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/").concat(id_pref_label, "/delete_pref_label"),
                method: "delete",
            });
        } }, options), queryClient);
};
exports.useDeletePrefLabel = useDeletePrefLabel;
// to create prefSlots for a prefLabel
// Endpoint: manager/itrs/<id_itr>/preferences/<id_pref_label>/create_pref_slots
var useCreatePrefSlots = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, pref_slots = params.pref_slots;
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/create_pref_slots"),
                method: "post",
                data: { pref_slots: pref_slots },
            });
        } }, options), queryClient);
};
exports.useCreatePrefSlots = useCreatePrefSlots;
// to delete prefSlots for a prefLabel
// Endpoint: manager/itrs/<id_itr>/preferences/delete_pref_slots
var useDeletePrefSlots = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, id_pref_slots = params.id_pref_slots;
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/delete_pref_slots"),
                method: "delete",
                data: { id_pref_slots: id_pref_slots },
            });
        } }, options), queryClient);
};
exports.useDeletePrefSlots = useDeletePrefSlots;
// to edit which sectionSlots belong to which prefSlots
// Endpoint: manager/itrs/<id_itr>/preferences/map_pref_slots
var useMapPrefSlots = function (queryClient, options) {
    return (0, react_query_1.useMutation)(__assign({ mutationFn: function (params) {
            var id_itr = params.id_itr, section_slot_to_pref_slot = params.section_slot_to_pref_slot;
            return (0, api_1.request)({
                url: "manager/itrs/".concat(id_itr, "/preferences/map_pref_slots"),
                method: "patch",
                data: { section_slot_to_pref_slot: section_slot_to_pref_slot },
            });
        } }, options), queryClient);
};
exports.useMapPrefSlots = useMapPrefSlots;
